import * as React from 'react';
import { Fragment } from 'react';

import type { Response as ChangedResponseType } from 'bundles/compound-assessments/components/local-state/changed-response/types';
import AiSuggestion from 'bundles/grading//components/staff-graded-assignments/ai-suggestions/AiSuggestion';
import { useAiSuggestionsContext } from 'bundles/grading//components/staff-graded-assignments/ai-suggestions/AiSuggestionsContext';
import { getChangeResponseInputFromAiSuggestion } from 'bundles/grading/utils/aiSuggestionsUtils';

type Props = {
  onChangeResponse: (changeResponse: ChangedResponseType) => void;
  children: React.ReactNode;
};

const OverrideFormPartChangeResponseWrapper = ({ onChangeResponse, children }: Props) => {
  const { currentAiReviewPartSuggestion } = useAiSuggestionsContext();

  const handleApplyAiSuggestion = () => {
    if (currentAiReviewPartSuggestion) {
      const changeResponseInput = getChangeResponseInputFromAiSuggestion(currentAiReviewPartSuggestion);
      if (changeResponseInput) {
        onChangeResponse(changeResponseInput);
      }
    }
  };

  return (
    <Fragment>
      {children}
      {!!currentAiReviewPartSuggestion && (
        <Fragment>
          <AiSuggestion applySuggestion={handleApplyAiSuggestion} />
        </Fragment>
      )}
    </Fragment>
  );
};

export default OverrideFormPartChangeResponseWrapper;
